(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brokerage-region', {
            parent: 'entity',
            url: '/brokerage-region?page&sort&search',
            data: {
                authorities: ['BROKERAGE_REGION_READ'],
                pageTitle: 'valueconnectApp.brokerageRegion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage-region/brokerage-regions.html',
                    controller: 'BrokerageRegionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerageRegion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brokerage-region-detail', {
            parent: 'entity',
            url: '/brokerage-region/{id}',
            data: {
                authorities: ['BROKERAGE_REGION_READ'],
                pageTitle: 'valueconnectApp.brokerageRegion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage-region/brokerage-region-detail.html',
                    controller: 'BrokerageRegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerageRegion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrokerageRegion', function($stateParams, BrokerageRegion) {
                    return BrokerageRegion.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('brokerage-region.new', {
            parent: 'brokerage-region',
            url: '/new',
            data: {
                authorities: ['BROKERAGE_REGION_CREATE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-region/brokerage-region-dialog.html',
                    controller: 'BrokerageRegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                disabled: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brokerage-region', null, { reload: true });
                }, function() {
                    $state.go('brokerage-region');
                });
            }]
        })
        .state('brokerage-region.edit', {
            parent: 'brokerage-region',
            url: '/{id}/edit',
            data: {
                authorities: ['BROKERAGE_REGION_UPDATE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-region/brokerage-region-dialog.html',
                    controller: 'BrokerageRegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrokerageRegion', function(BrokerageRegion) {
                            return BrokerageRegion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brokerage-region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brokerage-region.delete', {
            parent: 'brokerage-region',
            url: '/{id}/delete',
            data: {
                authorities: ['BROKERAGE_REGION_DESTROY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-region/brokerage-region-delete-dialog.html',
                    controller: 'BrokerageRegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrokerageRegion', function(BrokerageRegion) {
                            return BrokerageRegion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brokerage-region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
